import React from 'react';
import InfiniteSearchableSelect from '../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import InterveneSearchableSelect from './InterveneSearchableSelect';
import { fetchOrganisationListPage } from '../adapters/organisationListAdapter';
import {
  getOrganisationId,
  getOrganisationLabel,
  isSameOrganisation,
  mapOrganisationToSelectOption,
} from '../utils/organisationSelectUtils';

export default function InterveneOrganisationSearchableSelect({
  valueId = null,
  selectedOrganisation = null,
  onChange,
  pageSize = 20,
  ...props
}) {
  return (
    <InfiniteSearchableSelect
      {...props}
      fetchPage={fetchOrganisationListPage}
      pageSize={pageSize}
      enabled
      enableSearch
      minRemoteSearchLength={2}
      searchDebounceMs={350}
      searchStrategy="remote-only"
      injectSelectedWhileSearching={false}
      valueId={valueId}
      selectedSeed={selectedOrganisation}
      mapToOption={mapOrganisationToSelectOption}
      isSameOption={isSameOrganisation}
      getOptionId={getOrganisationId}
      getOptionLabel={getOrganisationLabel}
      isOptionEqualToValue={isSameOrganisation}
      onChange={onChange}
      SelectComponent={InterveneSearchableSelect}
      placeholder={props.placeholder || 'Search and select organisation'}
      noOptionsText="No organisations found"
    />
  );
}
